import React, { PureComponent } from 'react';
import 'antd/dist/antd.css';
import { Table, Modal } from 'antd';


const dataSource = [
  {
    key: '1',
    ID: '8807',
    name: 'Hatch',
    category: 'Train',
    activity: 'Dedicated Desk',
    hostname: 'John Doe',
    hostemail: 'johndoe@emil.com',
    spacename: 'Wonderful Coworking',
    datelisted: '15/06/202',
    action: 'Delete'
  },
  {
    key: '2',
    ID: '8807',
    name: 'Hatch',
    category: 'Train',
    activity: 'Dedicated Desk',
    hostname: 'John Doe',
    hostemail: 'johndoe@emil.com',
    spacename: 'Wonderful Coworking',
    datelisted: '15/06/202',
    action: 'Delete'
  },
  {
    key: '3',
    ID: '8807',
    name: 'Hatch',
    category: 'Train',
    activity: 'Dedicated Desk',
    hostname: 'John Doe',
    hostemail: 'johndoe@emil.com',
    spacename: 'Wonderful Coworking',
    datelisted: '15/06/202',
    action: 'Delete'
  },
  {
    key: '4',
    ID: '8807',
    name: 'Hatch',
    category: 'Train',
    activity: 'Dedicated Desk',
    hostname: 'John Doe',
    hostemail: 'johndoe@emil.com',
    spacename: 'Wonderful Coworking',
    datelisted: '15/06/202',
    action: 'Delete'
  },
];

const columns = [
  {
    title: 'Space ID',
    dataIndex: 'ID',
    key: 'ID',
  },
  {
    title: 'Organization Name',
    dataIndex: 'name',
    key: 'name',
    width: 150,
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    filters: [
      {
        text: 'Work',
        value: 'work',
      },
      {
        text: 'Meet',
        value: 'meet',
      },
      {
        text: 'Train',
        value: 'train',
      },
    ],
    onFilter: (value, record) => record.name.indexOf(value) === 0,
  },
  {
    title: 'Activity',
    dataIndex: 'activity',
    key: 'activity',
    filters: [
      {
        text: 'Work',
        value: 'work',
      },
      {
        text: 'Meet',
        value: 'meet',
      },
      {
        text: 'Train',
        value: 'train',
      },
    ],
    onFilter: (value, record) => record.name.indexOf(value) === 0,
  },
  {
    title: 'Host Name',
    dataIndex: 'hostname',
    key: 'hostname',
    width: 150,
  },
  {
    title: 'Host Email',
    dataIndex: 'hostemail',
    key: 'hostemail',
  },
  {
    title: 'Space Name',
    dataIndex: 'spacename',
    key: 'spacename',
    width: 150,
  },
  {
    title: 'Date Listed',
    dataIndex: 'datelisted',
    key: 'datelisted',
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: action => <span className="delete-text">{action}</span>
  },
];

const SpaceListing = () => {

  return (
      <section className="space-listing-section">
        <div className="container">
          <p className="title">Spaces</p>
          <Table className="space-listing-table" dataSource={dataSource} columns={columns} pagination={false} />;
        </div>
        <Modal
            visible={false}
            className="ms-styles-wrapper space-delete-modal"
            footer={null}
        >
          <div className="header">
            <p className="title">Deleting Space</p>
            <span className="content">Are you sure you want to delete the ‘Wonderful Coworking Space’?</span>
          </div>
          <div className="footer">
            <button className="btn btn-no">No</button>
            <button className="btn btn-yes">Yes</button>
          </div>
        </Modal>
      </section>
  );
};

export default SpaceListing;
